// ============================================================
// AppoinText Thank-You Page — editable config
// Fill these in. Nothing else in the project needs editing.
// ============================================================

// Haroon's confirmation & housekeeping video, shown at the top of the page.
// Autoplays muted; registrants tap for sound.
export const CONFIRMATION_VIDEO_URL = "/assets/workshop-confirmation-web.mp4";

// Meta Pixel ID is set in ONE place: public/index.html (window.META_PIXEL_ID).
// It is re-exported here so React code never hardcodes it.
export const META_PIXEL_ID = window.META_PIXEL_ID;
